import { themeAtom } from "../../atoms";
import Overlay, { OverlayProps } from "./Overlay";
import { useAtomValue } from "jotai";
import { ForwardedRef, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

const LoadingWrapperOverlay = forwardRef(
  ({ className = "h-full w-full", zIndex = 10 }: OverlayProps, ref: ForwardedRef<HTMLDivElement>) => {
    const theme = useAtomValue(themeAtom);

    return (
      <Overlay className={twMerge(theme.loadingWrapper.tailwind.overlayBg, className)} zIndex={zIndex} ref={ref} />
    );
  },
);

export default LoadingWrapperOverlay;
